import json from './sprite.js';

export default {
    handle: 'en_TOM-Toybox',
    label: 'en_TOM-Toybox',
    json,
};
